import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import * as shopActions from 'src/state/ducks/shop/actions';

import StyleConfig from 'src/constants/StyleConfig';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';

import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import Heading from 'src/components/atoms/typo/Heading';
import ListBlock from 'src/components/molecules/list/ListBlock';
import { PublishStatus4Option } from 'src/constants/StatusCode';

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class AdminShopPage extends Component<Props, State> {
  componentDidMount() {
    this.props.getShops();
  }

  transferShopPage = (id: string) => {
    this.props.pushUrl(`/shop/${id}/edit`);
  };

  renderNotFound = () => {
    return (
      <div>
        <p>表示する店舗が見つかりませんでした。</p>
      </div>
    );
  };

  renderShopList = (shops: Props['shops']) => (
    <section>
      <ul>
        {shops.map((shop, idx: number) => {
          const { id, name, publish_status } = shop;
          const status = PublishStatus4Option.find((s) => s.value === publish_status);
          return (
            <li key={idx}>
              <ListBlock
                clickEvent={() => this.transferShopPage(id)}
                listText={`${name}(${status ? status.content : '未設定'})`}
                listColor="primary"
              />
            </li>
          );
        })}
      </ul>
    </section>
  );

  render() {
    const { shops } = this.props;
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <Heading text="店舗一覧" />
          {shops.length > 0 ? this.renderShopList(shops) : this.renderNotFound()}
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
`;

const mapStateToProps = (state: State) => {
  return {
    shops: state.shop.resource,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getShops: () => dispatch(shopActions.getShops()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminShopPage);
